@if (item.title) {
  <h1 [class.mobile]="isMobile()">{{ item.title }}</h1>
}

@if (item.text && !item.textbold) {
  <div [ngClass]="isMobile() ? 'media-item-firstText' : 'item-firstText'">
    {{ item.text }}
  </div>
}

@if (item.text && item.textbold) {
  <div
    [ngClass]="
      isMobile() ? 'media-item-text-bold ele de' : 'item-text-bold ele'
    "
    [class.inlet-pop-up]="isInlet"
  >
    {{ item.text }} {{ isInlet }}
  </div>
}

@if (item.image) {
  <div class="photo-preview-wrapper">
    @if (item.marker && clientWidth()) {
      <div
        class="sensor-marker-wrapper"
        [ngStyle]="{
          'margin-left.px': item.marker.getClientX(
            clientWidth(),
            clientHeight(),
            naturalWidth(),
            naturalHeight()
          ),
          'margin-top.px': item.marker.getClientY(
            clientWidth(),
            clientHeight(),
            naturalWidth(),
            naturalHeight()
          ),
        }"
      >
        <div
          class="sensor-marker selected"
          [class.critical]="!item.marker.label"
          [ngStyle]="{
            'width.px': item.marker.circular
              ? item.marker.getAbsoluteDiameter(clientWidth())
              : item.marker.getAbsoluteWidth(clientWidth()),
            'height.px': item.marker.circular
              ? item.marker.getAbsoluteDiameter(clientWidth())
              : item.marker.getAbsoluteHeight(clientHeight()),
          }"
        ></div>
      </div>
    }

    <img
      nz-image
      nzDisablePreview
      (load)="onImageLoaded($event)"
      class="item-image"
      [nzSrc]="item.image"
      [class.mobile]="isMobile()"
      [alt]="'itemImage'"
    />
  </div>
}
